import colors from "../../base/colors";

const { primary } = colors;

const formLabel = {
  styleOverrides: {
    root: {
      fontVariant: "all-small-caps",
      color: primary.main,
    },
  },
};
export default formLabel;
